<template>
  <div class="h-screen overflow-y-auto scroll-smooth overflow-x-hidden" @scroll="updateSelectedPage">
    <!-- First Slide: Main Open Creatives -->
    <div class="relative h-[calc(100vh-112px)]" id="top">
      <Carousel :autoplay="10000" :wrap-around="true" @slide-start="onMainSlideChange" @update:modelValue="onMainSlideChange" v-model="currentSlideIndex" ref="mainCarousel">
        <Slide v-for="slide in images" :key="slide">
          <div
            :style="{ 'background-image': 'url(' + slide.image + ')' }"
            class="w-full h-screen bg-cover bg-center tw-flex flex-col justify-center relative"
          ></div>
          <div
            class="absolute bottom-0 left-0 h-2.5 bg-white opacity-30"
            :style="{ width: progressWidth}"
          ></div>
        </Slide>

      </Carousel>


      <!-- Navigation Down Button -->
      <div class="absolute bottom-5 left-1/2 transform -translate-x-1/2 tw-flex items-center justify-center z-10">
        <a href="#first" class="text-white">
          <icon name="circle-down" size="22" class="w-12 h-12 opacity-40 hover:opacity-60 transition-opacity"/>
        </a>
      </div>

      <!--      <div class="absolute h-screen w-screen top-0 left-0 z-[99]">

            </div>-->

      <!-- Content Overlay -->
      <div class="absolute inset-0 tw-flex items-center justify-center z-1">
        <div class="text-center px-4">
          <!-- Logo placeholder -->
          <a href="#" target="_blank" class="block w-36 mx-auto mb-4">
            <!--<img class="w-48 max-h-20 object-contain" :src="logoUrl" alt="open-creatives-logo"/>-->
          </a>
          <!-- Title with Navigation Arrows -->
          <div class="tw-flex items-center justify-center gap-6 mb-4 w-full max-w-6xl mx-auto px-4 z-1">
            <h1 class="text-white text-center flex-1 text-2xl md:text-5xl">
              {{ currentMainSlide.title }}
            </h1>
          </div>

          <h3 class="text-white text-center flex-1" style="font-size: 50px">
            {{ currentMainSlide.subtitle }}
          </h3>

          <div class="tw-flex flex-row items-center justify-center gap-6 mb-4 w-full max-w-6xl mx-auto px-4">
            <button @click="goToPreviousSlide"
                    class="group tw-flex items-center justify-center w-12 h-12 bg-white/30 hover:bg-white/50 rounded-full transition-all duration-300 backdrop-blur-sm border border-white/40">
              <icon name="chevron-left" class="text-white text-xl group-hover:scale-110 transition-transform duration-300"/>
            </button>
            <div class="static-home-open-creatives__buttons">
              <router-link to="/register" target="_self" class="font-bold !text-[16px]" variant="secondary">Doe mee</router-link>
            </div>
            <button @click="goToNextSlide"
                    class="group tw-flex items-center justify-center w-12 h-12 bg-white/30 hover:bg-white/50 rounded-full transition-all duration-300 backdrop-blur-sm border border-white/40">
              <icon name="chevron-right" class="text-white text-xl group-hover:scale-110 transition-transform duration-300"/>
            </button>
          </div>
        </div>
      </div>

      <!-- Navigation Circles with City Labels -->
      <div class="hidden sm:tw-flex fixed right-2 sm:right-4 lg:right-16 top-1/2 transform -translate-y-1/2 !flex-col space-y-3 sm:space-y-4 lg:space-y-6 no-underline z-30">
        <a href="#top" class="tw-flex items-center space-x-2 sm:space-x-3 hover:-translate-x-1 sm:hover:-translate-x-2 transition-all duration-300 !no-underline">
          <div :class="selectedPage === 'zero' ? 'bg-white text-black' : 'bg-white/40 text-white hover:bg-white/60'"
               class="px-2 sm:px-3 lg:px-4 py-1 sm:py-2 rounded-full transition-all duration-300 no-underline w-16 sm:w-20 lg:w-32 text-center text-xs sm:text-sm lg:text-base">Home
          </div>
        </a>
        <a href="#first" class="tw-flex items-center space-x-2 sm:space-x-3 hover:-translate-x-1 sm:hover:-translate-x-2 transition-all duration-300 !no-underline">
          <div :class="selectedPage === 'first' ? 'bg-white text-black' : 'bg-white/40 text-white hover:bg-white/60'"
               class="px-2 sm:px-3 lg:px-4 py-1 sm:py-2 rounded-full transition-all duration-300 !no-underline w-16 sm:w-20 lg:w-32 text-center text-xs sm:text-sm lg:text-base">
            Gent
          </div>
        </a>
        <a href="#second" class="tw-flex items-center space-x-2 sm:space-x-3 hover:-translate-x-1 sm:hover:-translate-x-2 transition-all duration-300 !no-underline">
          <div :class="selectedPage === 'second' ? 'bg-white text-black' : 'bg-white/40 text-white hover:bg-white/60'"
               class="px-2 sm:px-3 lg:px-4 py-1 sm:py-2 rounded-full transition-all duration-300 no-underline w-16 sm:w-20 lg:w-32 text-center text-xs sm:text-sm lg:text-base">
            Leuven
          </div>
        </a>
        <a href="#third" class="tw-flex items-center space-x-2 sm:space-x-3 hover:-translate-x-1 sm:hover:-translate-x-2 transition-all duration-300 !no-underline">
          <div :class="selectedPage === 'third' ? 'bg-white text-black' : 'bg-white/40 text-white hover:bg-white/60'"
               class="px-2 sm:px-3 lg:px-4 py-1 sm:py-2 rounded-full transition-all duration-300 no-underline w-16 sm:w-20 lg:w-32 text-center text-xs sm:text-sm lg:text-base">
            Waasland
          </div>
        </a>
        <a href="#fourth" class="tw-flex items-center space-x-2 sm:space-x-3 hover:-translate-x-1 sm:hover:-translate-x-2 transition-all duration-300 !no-underline">
          <div :class="selectedPage === 'fourth' ? 'bg-white text-black' : 'bg-white/40 text-white hover:bg-white/60'"
               class="px-2 sm:px-3 lg:px-4 py-1 sm:py-2 rounded-full transition-all duration-300 no-underline w-16 sm:w-20 lg:w-32 text-center text-xs sm:text-sm lg:text-base">
            Zuidwest
          </div>
        </a>
        <!--        <a href="#" class="tw-flex items-center space-x-2 sm:space-x-3 hover:-translate-x-1 sm:hover:-translate-x-2 transition-all duration-300 !no-underline">
                  <div :class="'bg-white/40 text-white hover:bg-white/60'"
                       class="px-2 sm:px-3 lg:px-4 py-1 sm:py-2 rounded-full transition-all duration-300 no-underline w-18 sm:w-20 lg:w-32 text-center text-xs sm:text-sm lg:text-base">
                    Jouw regio?
                  </div>
                </a>-->
      </div>
    </div>

    <!-- Gent Section -->
    <div class="relative h-[calc(100vh-112px)]" id="first">
      <div
        style="background-image: url('/images/static-home-page/openCreatives/static-home-opencreatives-second-image.png')"
        class="w-full h-[calc(100vh-112px)] bg-cover bg-center tw-flex flex-col justify-center relative"
      ></div>

      <!-- Content Overlay -->
      <div class="absolute inset-0 tw-flex items-center justify-center">
        <div class="text-center px-4">
          <h1 class="text-white text-center mb-4 w-full max-w-4xl mx-auto px-4" style="font-size: 50px">
            Open Creatives Gent
          </h1>
          <h3 class="text-center text-white text-base sm:text-lg md:text-xl mb-8 md:mb-10 px-4">
            De real-time heartbeat van de creatieve sector in Gent en ver daarbuiten.
          </h3>

          <!-- Buttons for Gent -->
          <div class="tw-flex flex-col justify-center items-center gap-4 mt-8 px-4">
            <div class="static-home-open-creatives__buttons tw-flex flex-col md:flex-row justify-center items-center gap-3 md:gap-4">
              <router-link to="/spotting-areas/512/actors" target="_self" class="font-bold !text-[16px]" variant="secondary">Ontdek de creatieve actoren</router-link>
              <router-link to="/spotting-areas/512/products" target="_self" class="font-bold !text-[16px]" variant="secondary">Ontdek de creatieve ruimtes</router-link>
              <!--              <ds-button to="/communities/88/events" target="_self" label="Event" variant="secondary"/>
                            <ds-button to="/communities/88/announcements" target="_self" label="Kansen" variant="secondary"/>-->
            </div>
            <div class="static-home-open-creatives__buttons-secondary">
              <!--              <ds-button to="/communities/88/" label="Ontdek de community" variant="secondary"/>-->
              <ds-button to="/register?redirect_uri=/communities/88/" label="Doe mee met Open Creatives Gent" class="!text-[16px]" variant="secondary"/>
            </div>
          </div>
        </div>
      </div>

      <!-- Navigation Down Button -->
      <div class="absolute bottom-5 left-1/2 transform -translate-x-1/2 tw-flex items-center justify-center">
        <a href="#second" class="text-white">
          <icon name="circle-down" size="22" class="w-12 h-12 opacity-40 hover:opacity-60 transition-opacity"/>
        </a>
      </div>
    </div>

    <!-- Leuven Section -->
    <div class="relative h-[calc(100vh-112px)]" id="second">
      <div
        style="background-image: url('/images/static-home-page/openCreatives/static-home-opencreatives-home-first-image.png')"
        class="w-full h-[calc(100vh-112px)] bg-cover bg-center tw-flex flex-col justify-center relative"
      ></div>

      <!-- Content Overlay -->
      <div class="absolute inset-0 tw-flex items-center justify-center">
        <div class="text-center px-4">
          <h1 class="text-white text-center mb-4 w-full max-w-4xl mx-auto px-4" style="font-size: 50px">
            Open Creatives Leuven
          </h1>
          <h3 class="text-center text-white text-base sm:text-lg md:text-xl mb-8 md:mb-10 px-4">
            De one stop shop voor en door het culturele veld van Leuven.
          </h3>

          <!-- Buttons for Leuven -->
          <div class="tw-flex flex-col justify-center items-center gap-4 mt-8 px-4">
            <div class="static-home-open-creatives__buttons tw-flex flex-col md:flex-row justify-center items-center gap-3 md:gap-4">
              <router-link to="/spotting-areas/513/actors" target="_self" class="font-bold !text-[16px]" variant="secondary">Ontdek de creatieve
                actoren
              </router-link>
              <router-link to="/spotting-areas/513/products" target="_self" class="font-bold !text-[16px]" variant="secondary">Ontdek de creatieve ruimtes</router-link>
            </div>
            <div class="static-home-open-creatives__buttons-secondary">
              <ds-button to="/register?redirect_uri=/communities/89/" label="Doe mee met Open Creatives Leuven" class="!text-[16px]" variant="secondary"/>
            </div>
          </div>
        </div>
      </div>

      <!-- Navigation Down Button -->
      <div class="absolute bottom-5 left-1/2 transform -translate-x-1/2 tw-flex items-center justify-center">
        <a href="#third" class="text-white">
          <icon name="circle-down" size="22" class="w-12 h-12 opacity-40 hover:opacity-60 transition-opacity"/>
        </a>
      </div>
    </div>

    <!-- Waasland Section -->
    <div class="relative h-[calc(100vh-112px)]" id="third">
      <div
        style="background-image: url('/images/static-home-page/openCreatives/waasland/home/Lokeren/lokeren_1.jpg')"
        class="w-full h-[calc(100vh-112px)] bg-cover bg-center tw-flex flex-col justify-center relative"
      ></div>

      <!-- Content Overlay -->
      <div class="absolute inset-0 tw-flex items-center justify-center">
        <div class="text-center px-4">
          <h1 class="text-white text-center mb-4 w-full max-w-4xl mx-auto px-4" style="font-size: 50px">
            Open Creatives Waasland
          </h1>
          <h3 class="text-center text-white text-base sm:text-lg md:text-xl mb-8 md:mb-10 px-4">
            De digitale plek waar de culturele en creatieve sector van het Waasland samenkomt, deelt en groeit.
          </h3>

          <!-- Buttons for Waasland -->
          <div class="tw-flex flex-col justify-center items-center gap-4 mt-8 px-4">
            <div class="static-home-open-creatives__buttons tw-flex flex-col md:flex-row justify-center items-center gap-3 md:gap-4">
              <router-link to="/spotting-areas/514/actors" target="_self" class="font-bold !text-[16px]" variant="secondary">Ontdek de creatieve actoren</router-link>
              <router-link to="/spotting-areas/514/products" target="_self" class="font-bold !text-[16px]" label=""
                           variant="secondary">Ontdek de creatieve ruimtes
              </router-link>
            </div>
            <div class="static-home-open-creatives__buttons-secondary">
              <ds-button to="/register?redirect_uri=/communities/92/" label="Doe mee met Open Creatives Waasland" class="!text-[16px]" variant="secondary"/>
            </div>
          </div>
        </div>
      </div>

      <!-- Navigation Down Button -->
      <div class="absolute bottom-5 left-1/2 transform -translate-x-1/2 tw-flex items-center justify-center">
        <a href="#fourth" class="text-white">
          <icon name="circle-down" size="22" class="w-12 h-12 opacity-40 hover:opacity-60 transition-opacity"/>
        </a>
      </div>
    </div>

    <!-- Zuidwest Section -->
    <div class="relative h-[calc(100vh-112px)]" id="fourth">
      <div
        style="background-image: url('/images/static-home-page/openCreatives/zuidwest/home/Lendelede/lendelede-4.jpg')"
        class="w-full h-[calc(100vh-112px)] bg-cover bg-center tw-flex flex-col justify-center relative"
      ></div>

      <!-- Content Overlay -->
      <div class="absolute inset-0 tw-flex items-center justify-center">
        <div class="text-center px-4">
          <h1 class="text-white text-center mb-4 w-full max-w-4xl mx-auto px-4" style="font-size: 50px">
            Open Creatives Zuidwest
          </h1>
          <h3 class="text-center text-white text-base sm:text-lg md:text-xl mb-8 md:mb-10 px-4">
            De community waar de creatieve sector van Zuidwest samenkomt, deelt en groeit.
          </h3>

          <!-- Buttons for Zuidwest -->
          <div class="tw-flex flex-col justify-center items-center gap-4 mt-8 px-4">
            <div class="static-home-open-creatives__buttons tw-flex flex-col md:flex-row justify-center items-center gap-3 md:gap-4">
              <router-link to="/spotting-areas/515/actors" target="_self" class="font-bold !text-[16px]" variant="secondary">Ontdek de creatieve actoren</router-link>
              <router-link to="/spotting-areas/515/products" target="_self" class="font-bold !text-[16px]" variant="secondary">Ontdek de creatieve ruimtes</router-link>
            </div>
            <div class="static-home-open-creatives__buttons-secondary">
              <ds-button to="/register?redirect_uri=/communities/90/" label="Doe mee met Open Creatives Zuidwest" class="!text-[16px]" variant="secondary"/>
            </div>
          </div>
        </div>
      </div>

      <!-- Navigation Down Button -->
      <div class="absolute bottom-5 left-1/2 transform -translate-x-1/2 tw-flex items-center justify-center">
        <a href="#footer" class="text-white">
          <icon name="circle-down" size="22" class="w-12 h-12 opacity-40 hover:opacity-60 transition-opacity"/>
        </a>
      </div>
    </div>


    <!-- Footer -->
    <SimplifiedFooterOpenCreatives id="footer" class="relative bg-[#312782]"/>
  </div>
</template>


<script lang="ts">
  import SimplifiedFooterOpenCreatives from '../SimplifiedFooter/SimplifiedFooterOpenCreatives.vue'
  import { Carousel, Navigation, Slide } from 'vue3-carousel'
  import { MUTATION_TYPES as UI_MUTATION_TYPES } from '../../store/modules/ui.js'
  import { trackHeapEvent } from '../../util/analytics.js'
  import MODAL_IDS from '../../constants/modal-ids.js'
  import { defineComponent } from "vue";

  export default defineComponent({
    components: {
      SimplifiedFooterOpenCreatives,
      Carousel,
      Slide,
      Navigation,
    },
    data() {
      return {
        progressWidth: null,
        progressInterval: null,
        selectedPage: 'zero',
        currentSlideIndex: 0,
        images: [
          {
            image: '/images/static-home-page/openCreatives/static-home-opencreatives-first-image.png',
            title: 'Open Creatives',
            subtitle: 'Platform voor de creatieve- en cultuursector'
          },
          {
            image: '/images/static-home-page/openCreatives/static-home-opencreatives-third-image.png',
            title: 'Vind en word gevonden! Connecteer, interageer, deel en creëer in onze creatieve gemeenschap. Naar wat ben jij op zoek?',
            subtitle: ''
          },
          {
            image: '/images/static-home-page/openCreatives/waasland/home/Sint-Niklaas/sint-niklaas.jpg',
            title: 'Word als organisatie gevonden, plaats je ruimte online of lanceer kansen, vacatures e.a.',
            subtitle: ''
          },
          {
            image: '/images/static-home-page/openCreatives/zuidwest/home/Wervik/wervik-2.jpg',
            title: 'Open Creatives',
            subtitle: 'Platform voor de creatieve- en cultuursector'
          },
          {
            image: '/images/static-home-page/openCreatives/zuidwest/home/Wevelgem/wevelgem-2.jpg',
            title: 'Vind en word gevonden! Connecteer, interageer, deel en creëer in onze creatieve gemeenschap. Naar wat ben jij op zoek?',
            subtitle: ''
          },
          {
            image: '/images/static-home-page/openCreatives/zuidwest/home/Kortrijk/kortrijk_6.png',
            title: 'Word als organisatie gevonden, plaats je ruimte online of lanceer kansen, vacatures e.a.',
            subtitle: ''
          },
        ],
      }
    },
    computed: {
      logoUrl() {
        return this.config.logo_url_light || this.config.logo_url
      },
      config() {
        return this.$store.state.config
      },
      currentMainSlide() {
        return this.images[this.currentSlideIndex] || this.images[0]
      },
    },
    methods: {
      updateSelectedPage(event) {
        const scrollHeight = event.target.scrollHeight
        const clientHeight = event.target.clientHeight
        const scrollTop = event.target.scrollTop
        const maxScroll = scrollHeight - clientHeight

        if (scrollTop > maxScroll * 4 / 5) {
          this.selectedPage = 'fourth'
        } else if (scrollTop > maxScroll * 3 / 5) {
          this.selectedPage = 'third'
        } else if (scrollTop > maxScroll * 2 / 5) {
          this.selectedPage = 'second'
        } else if (scrollTop > maxScroll / 5) {
          this.selectedPage = 'first'
        } else {
          this.selectedPage = 'zero'
        }
      },
      openSignupModal() {
        trackHeapEvent('staticHomePage.topBarRegister')
        if (this.$store.getters.hasAccessToEcosystemMemberPackages) {
          this.$store.commit(UI_MUTATION_TYPES.SHOW_MODAL, MODAL_IDS.PACKAGES_SIGN_UP)
        } else if (this.$store.state.config.allowAdd) {
          this.$store.commit(UI_MUTATION_TYPES.SHOW_MODAL, MODAL_IDS.ACTOR_SIGN_UP)
        } else {
          this.$store.commit(UI_MUTATION_TYPES.SHOW_MODAL, MODAL_IDS.SIGN_UP)
        }
      },
      // Handle carousel slide changes
      onMainSlideChange(data) {
        this.currentSlideIndex = data.currentSlideIndex || data
      },
      // Manual navigation methods
      goToNextSlide() {
        const nextIndex = (this.currentSlideIndex + 1) % this.images.length
        this.currentSlideIndex = nextIndex
        if (this.$refs.mainCarousel) {
          this.$refs.mainCarousel.slideTo(nextIndex)
        }
      },
      goToPreviousSlide() {
        const prevIndex = this.currentSlideIndex === 0 ? this.images.length - 1 : this.currentSlideIndex - 1
        this.currentSlideIndex = prevIndex
        if (this.$refs.mainCarousel) {
          this.$refs.mainCarousel.slideTo(prevIndex)
        }
      },
      imageTimer() {
        let startDate = new Date().getTime()
        let newDate = new Date().getTime()
        this.progressInterval = setInterval(() => {
          newDate = new Date().getTime()
          const difference = newDate - startDate
          if (difference < 10000) {
            this.progressWidth = `${difference / 100}%`
          } else {
            startDate = new Date().getTime()
          }
        }, 10)
      },
    },
    mounted() {
      this.imageTimer()
    },
    beforeUnmount() {
      clearInterval(this.progressInterval)
    },
  })
</script>

<style lang="scss" scoped>
  @import "../../../scss/variables";

  .static-home-open-creatives__buttons-secondary {
    :deep(.button) {
      border-radius: 4px;
      border: 3px solid #00ff7b;
      background-color: rgba(0, 255, 123, 0.8);
      transition: all 0.3s ease;
      margin: 0.25rem;

      &:hover {
        background-color: rgba(0, 255, 123, 1);
        box-shadow: 0 4px 12px rgba(0, 255, 123, 0.3);
        transform: translateY(-2px);
      }
    }

    :deep(.button__label) {
      color: #fff;
      text-transform: none;
    }
  }

  .static-home-open-creatives__buttons {
    a {
      border-radius: 4px;
      border: 3px solid #0043ff;
      background-color: rgba(0, 67, 255, 0.8);
      transition: all 0.3s ease;
      margin: 0.25rem;
      text-decoration: none;
      padding: 0.5rem 0.75rem;

      &:hover {
        background-color: rgba(0, 67, 255, 1);;
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 67, 255, 0.3);;
      }
    }

    a {
      color: #fff;
    }
  }
</style>

